import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import InvoiceStatusTag from 'components/InvoiceStatusTag';
import {formatDate} from 'utils/datetime';

import {
  SCHEDULE_ITEM_TYPES,
  SCHEDULE_TYPES_HUMAN_VALUES,
  SCHEDULE_TYPES
} from 'ducks/tenancy';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

const InvoiceRow = ({
  invoice,
  handleRowClick,
  redirectToBookingDetail,
  advancedMode
}) => {
  const {invoiceDetails} = invoice;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: invoice.highlighted
      })}
      onClick={() =>
        handleRowClick({
          item: SCHEDULE_ITEM_TYPES.INVOICE,
          itemId: invoice.id,
          scheduleType: SCHEDULE_TYPES[invoice.scheduleType],
          tenancyId: invoiceDetails.tenancyId
        })
      }>
      <Table.Cell className="booking">
        <ClickIconWithNoPropagation
          onClick={() =>
            redirectToBookingDetail({bookingId: invoice.bookingId})
          }>
          <div className="colab-bold">#{invoice.bookingId}</div>
        </ClickIconWithNoPropagation>
      </Table.Cell>
      <Table.Cell className="date">{formatDate(invoice.date)}</Table.Cell>
      {advancedMode && (
        <Table.Cell className="dueDate">
          {formatDate(invoiceDetails.dueDate)}
        </Table.Cell>
      )}
      <Table.Cell className="type">
        <div className="colab-centered-v">
          {invoiceDetails.hasXeroErrors && <Alert />}
          <div className="colab-centered-v">Invoice</div>
        </div>
      </Table.Cell>
      <Table.Cell className="description">
        {invoiceDetails.description}
      </Table.Cell>
      <Table.Cell className="category">
        {_.get(SCHEDULE_TYPES_HUMAN_VALUES, invoice.scheduleType)}
      </Table.Cell>
      <Table.Cell className="status">
        <InvoiceStatusTag
          overdue={invoiceDetails.overdue}
          status={invoiceDetails.status}
        />
      </Table.Cell>
      <Table.Cell className="amount due">
        <Money
          amount={invoice.amount}
          balance
          className={classNames({
            strikeThrough: invoiceDetails.voided
          })}
        />
      </Table.Cell>
      {advancedMode && <Table.Cell className="payment" />}
      <Table.Cell className="balance">
        <Money amount={invoice.balance} balance />
      </Table.Cell>
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default InvoiceRow;
